/**
 * The snapshot: v1 → v2 (decision 0036, spec §2.10). A stored v1 snapshot is the compacted v1 state; items are built
 * with the same functions the event upcaster uses (initiatives, tasks, then open intake with its capture seq).
 * Resolved intake that v1 compaction dropped stays absent (it was already gone).
 */
import type * as V1 from "../legacy/v1/index"
import type { ProjectState } from "../state"
import { fromV1Proposal } from "./events"
import { fromV1Edge, fromV1Initiative, fromV1Intake, fromV1Task } from "./item"
import { fromV1Policy } from "./policy"
import {
  fromV1Agent,
  fromV1Area,
  fromV1Artifact,
  fromV1Comment,
  fromV1Goal,
  fromV1Kpi,
  fromV1MemoryItem,
  fromV1Project,
  fromV1Run,
} from "./records"

export const fromV1State = (s: V1.ProjectState): ProjectState => ({
  v: 2,
  seq: s.seq,
  planVersion: s.planVersion,
  project: s.project === null ? null : fromV1Project(s.project),
  members: s.members,
  mayor: s.mayor,
  policies: s.policies.map(fromV1Policy),
  areas: s.areas.map(fromV1Area),
  agents: s.agents.map(fromV1Agent),
  goals: s.goals.map(fromV1Goal),
  kpis: s.kpis.map(fromV1Kpi),
  items: [
    ...s.initiatives.map(fromV1Initiative),
    ...s.tasks.map(fromV1Task),
    ...s.intake.map((x) => fromV1Intake(x, x.contentSeq)),
  ],
  edges: s.edges.map(fromV1Edge),
  proposals: s.proposals.map(fromV1Proposal),
  runs: s.runs.map(fromV1Run),
  openAsks: s.openAsks.map(fromV1Comment),
  artifacts: s.artifacts.map(fromV1Artifact),
  memory: s.memory.map(fromV1MemoryItem),
  refCounters: s.refCounters,
})
